import script from "./ResumeAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeAdd.vue?vue&type=script&setup=true&lang=js"

import "./ResumeAdd.vue?vue&type=style&index=0&id=09b66450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b66450"]])

export default __exports__